export enum AppRoutes {
  Home = "/home",
  BridgeToDesktop = "/app/*",

  // #region Auth Routes
  Login = "/login",
  PrescriptionExpired = "/prescription-expired",
  InvalidPrescriptionState = "/invalid-prescription",
  PatientDisconnected = "/patient-disconnected",
  // #endregion

  // #region settings Routes
  Settings = "/settings",
  AccountSettings = "/settings/account",
  ClinicSettings = "/settings/clinic",
  LanguageSettings = "/settings/language",
  NotificationSettings = "/settings/notification",
  CoachSettings = "/settings/coach",
  SoundSettings = "/settings/sound",
  ThemeSettings = "/settings/theme",
  VoiceSettings = "/settings/voice",
  TermsAndConditionsSettings = "/settings/terms-and-conditions",
  PrivacyPolicyAndDataTransparencySettings = "/settings/privacy-policy-and-data-transparency",
  IFUSettings = "/settings/ifu",
  ReleaseNotes = "/settings/release-notes",
  // #endregion

  // #region dashboard Routes
  Dashboard = "/dashboard",
  DashboardToday = "/dashboard/today",
  DashboardShorts = "/dashboard/shorts",
  DashboardAnalysis = "/dashboard/analysis",
  DashboardTherapyPlan = "/dashboard/therapy-plan",
  DashboardProfile = "/dashboard/profile",
  // #endregion

  // #region camera Routes
  NextSession = "/treatments/:treatmentId/next-session",
  SessionSelfReflectionPain = "/treatments/:treatmentId/sessions/:sessionId/self-reflection/pain",
  SessionSelfReflectionPainfulExercises = "/treatments/:treatmentId/sessions/:sessionId/self-reflection/painful-exercises",
  SessionSelfReflectionDifficulty = "/treatments/:treatmentId/sessions/:sessionId/self-reflection/difficulty",
  SessionSelfReflectionDifficultExercises = "/treatments/:treatmentId/sessions/:sessionId/self-reflection/difficult-exercises",
  SessionSelfReflectionFeedback = "/treatments/:treatmentId/sessions/:sessionId/self-reflection/feedback",
  SessionRecap = "/treatments/:treatmentId/sessions/:sessionId/recap",
  // #endregion

  // #region Onboarding Routes
  Onboarding = "/onboarding",
  OnboardingConfirmEmail = "/onboarding/confirm-email",
  OnboardingVerify = "/onboarding/verify",
  OnboardingInvitationCode = "/onboarding/invitation-code",
  OnboardingTermsAndConditions = "/onboarding/terms-and-conditions",
  RevokedInvitation = "/onboarding/revoked-invitation",
  AlreadyUsedCode = "/onboarding/already-used-code",
  OnboardingError = "/onboarding/error",
  // #endregion

  // #region Legal Routes
  TermsAndConditions = "/terms-and-conditions",
  PrivacyPolicyAndDataTransparency = "/privacy-policy-and-data-transparency",
  IFU = "/instructions-for-use",
  // #endregion

  // #region Reactions
  ReactionsFromEmail = "/reaction/from-email",
  // #endregion

  // #region Payment Routes
  PaymentSuccess = "/payment-success",
  // #endregion
}

const _PUBLIC_ROUTE_PATHS = [
  AppRoutes.Home,
  AppRoutes.BridgeToDesktop,
  AppRoutes.ReactionsFromEmail,
  AppRoutes.TermsAndConditions,
  AppRoutes.PrivacyPolicyAndDataTransparency,
  AppRoutes.IFU,
  AppRoutes.PaymentSuccess,
] as const;

const _GUEST_ROUTE_PATHS = [
  AppRoutes.Login,
  AppRoutes.Onboarding,
  AppRoutes.OnboardingInvitationCode,
  AppRoutes.OnboardingError,
  AppRoutes.RevokedInvitation,
  AppRoutes.AlreadyUsedCode,
] as const;

export type PublicRoutePath = (typeof _PUBLIC_ROUTE_PATHS)[number];
type GuestRoutePath = (typeof _GUEST_ROUTE_PATHS)[number];
// All AppRoutes values not explicitly listed as public or guest are protected — no need to enumerate them
type ProtectedRoutePath = Exclude<AppRoutes, PublicRoutePath | GuestRoutePath>;


export function guestPath(path: GuestRoutePath): GuestRoutePath {
  return path;
}

export function protectedPath(path: ProtectedRoutePath): ProtectedRoutePath {
  return path;
}